/**
 * Simulador de frete na PDP — CEP + faixas por peso (Envio Express).
 */
(function (global) {
  'use strict';

  var CEP_CACHE_KEY = 'vestfirma_pdp_shipping_cep_v1';

  function readConfig(el) {
    var script = el.querySelector('[data-md-shipping-calc-config]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function normalizeCep(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCep(value) {
    var digits = normalizeCep(value);
    if (digits.length <= 5) return digits;
    return digits.slice(0, 5) + '-' + digits.slice(5);
  }

  function formatMoney(cents, moneyFormat, currencyCode) {
    var amount = (Number(cents) || 0) / 100;
    if (moneyFormat && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    try {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: currencyCode || 'BRL',
      }).format(amount);
    } catch (err) {
      return 'R$ ' + amount.toFixed(2).replace('.', ',');
    }
  }

  function weightForVariant(config, variantId) {
    var variants = config.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (Number(variants[i].id) === Number(variantId)) {
        return Number(variants[i].weightGrams) || config.defaultWeightGrams || 300;
      }
    }
    return config.defaultWeightGrams || 300;
  }

  function priceForWeightKg(config, totalKg) {
    var tiers = config.weightTiers || [];
    for (var i = 0; i < tiers.length; i += 1) {
      var tier = tiers[i];
      if (totalKg >= tier.minKg && totalKg <= tier.maxKg) {
        return tier.priceCents;
      }
    }
    if (tiers.length) return tiers[tiers.length - 1].priceCents;
    return null;
  }

  function transitDaysForUf(uf) {
    if (
      global.VestfirmaPdpDeliveryEstimate &&
      typeof global.VestfirmaPdpDeliveryEstimate.transitDaysForUf === 'function'
    ) {
      return global.VestfirmaPdpDeliveryEstimate.transitDaysForUf(uf);
    }
    return 8;
  }

  function isProntaEntregaActive(el) {
    var pdp = el.closest('[data-md-pdp]');
    if (!pdp) return false;
    var meta = pdp.querySelector('[data-md-stock]');
    if (!meta || !meta.hasAttribute('data-production-full')) return false;
    return meta.classList.contains('md-pdp__meta--in-stock');
  }

  function computeDeliveryDays(el, uf) {
    var productionDays = Number(el.dataset.productionDays) || 4;
    var dispatchDays = Number(el.dataset.dispatchDays) || 1;
    var prontaDispatchDays = Number(el.dataset.prontaDispatchDays) || 2;
    var transit = transitDaysForUf(uf);

    if (el.dataset.prontaEntrega === 'true' && isProntaEntregaActive(el)) {
      return prontaDispatchDays + transit;
    }

    return productionDays + dispatchDays + transit;
  }

  function getStandardQuantity(root) {
    var wholesale = root.querySelector('vestfirma-pdp-wholesale');
    if (wholesale && typeof wholesale.getTotalQuantity === 'function') {
      var wholesaleQty = wholesale.getTotalQuantity();
      if (wholesaleQty > 0) return wholesaleQty;
    }

    var qtyInput =
      root.querySelector('quantity-selector input[type="number"]') ||
      root.querySelector('[data-md-product-form] input[name="quantity"]') ||
      root.querySelector('input[name="quantity"]');
    return Math.max(1, Number(qtyInput && qtyInput.value) || 1);
  }

  function getWholesaleLineTotalCents(root, config) {
    var wholesale = root.querySelector('vestfirma-pdp-wholesale');
    if (!wholesale || typeof wholesale.getTotalQuantity !== 'function') return null;

    var totalQty = wholesale.getTotalQuantity();
    if (totalQty < 1) return 0;

    var unitPrice = wholesale.getUnitPrice ? wholesale.getUnitPrice(totalQty) : null;
    if (unitPrice == null) {
      var pdp = root.closest('[data-md-pdp]');
      unitPrice = pdp ? Number(pdp.dataset.variantPrice) || 0 : 0;
    }

    return totalQty * unitPrice;
  }

  function getLineTotalCents(root, config) {
    var wholesaleTotal = getWholesaleLineTotalCents(root, config);
    if (wholesaleTotal != null) return wholesaleTotal;

    var pdp = root.closest('[data-md-pdp]');
    var priceCents = pdp ? Number(pdp.dataset.variantPrice) || 0 : 0;
    return priceCents * getStandardQuantity(root);
  }

  function getTotalWeightGrams(root, config) {
    var wholesale = root.querySelector('vestfirma-pdp-wholesale');
    if (wholesale && typeof wholesale.buildCartItems === 'function') {
      var items = wholesale.buildCartItems();
      if (items && items.length) {
        var total = 0;
        for (var i = 0; i < items.length; i += 1) {
          total += weightForVariant(config, items[i].id) * (Number(items[i].quantity) || 0);
        }
        if (total > 0) return total;
      }
    }

    var variantInput = root.querySelector('[data-md-product-form] [name="id"]');
    var variantId = variantInput ? Number(variantInput.value) : 0;
    return weightForVariant(config, variantId) * getStandardQuantity(root);
  }

  function fetchViaCep(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/', { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('cep');
        return res.json();
      })
      .then(function (json) {
        if (!json || json.erro) throw new Error('cep');
        return json;
      });
  }

  function applyTemplate(tpl, vars) {
    var out = tpl || '';
    Object.keys(vars).forEach(function (key) {
      out = out.replace(new RegExp('__' + key.toUpperCase() + '__', 'g'), vars[key]);
      out = out.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), vars[key]);
    });
    return out;
  }

  function renderResult(el, html, isError) {
    var result = el.querySelector('[data-md-shipping-calc-result]');
    if (!result) return;
    result.hidden = false;
    result.classList.toggle('is-error', !!isError);
    result.innerHTML = html;
  }

  function setLoading(el, config, loading) {
    var btn = el.querySelector('[data-md-shipping-calc-submit]');
    var input = el.querySelector('[data-md-shipping-cep]');
    if (btn) {
      btn.disabled = loading;
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
    if (input) input.disabled = loading;
    if (loading) {
      renderResult(el, '<p>' + (config.i18n.loading || 'Calculando…') + '</p>', false);
    }
  }

  function calculate(el, config) {
    var root = el.closest('[data-md-pdp]') || document;
    var input = el.querySelector('[data-md-shipping-cep]');
    var cep = normalizeCep(input && input.value);
    var pdp = el.closest('[data-md-pdp]');
    var moneyFormat = pdp ? pdp.dataset.moneyFormat : '';
    var currencyCode = pdp ? pdp.dataset.currencyCode : 'BRL';
    var i18n = config.i18n || {};
    var methodName = config.methodName || 'Envio Express';

    if (cep.length !== 8) {
      renderResult(el, '<p>' + (i18n.invalidCep || 'CEP inválido.') + '</p>', true);
      return;
    }

    try {
      sessionStorage.setItem(CEP_CACHE_KEY, cep);
    } catch (err) {
      /* ok */
    }

    setLoading(el, config, true);

    fetchViaCep(cep)
      .then(function (address) {
        var uf = String(address.uf || '').toUpperCase();
        var totalGrams = getTotalWeightGrams(root, config);
        var totalKg = totalGrams / 1000;
        var shippingCents = priceForWeightKg(config, totalKg);
        var lineTotalCents = getLineTotalCents(root, config);
        var pixDiscount = Number(config.pixDiscountPercent) || 0;
        var pixTotal = Math.round(lineTotalCents * (1 - pixDiscount / 100));
        var qualifiesFree = pixTotal >= Number(config.freeShippingMinCents);
        var deliveryDays = computeDeliveryDays(el, uf);
        var deliveryTpl =
          el.dataset.prontaEntrega === 'true' && isProntaEntregaActive(el)
            ? i18n.deliveryPronta
            : i18n.delivery;

        var html = '';
        if (qualifiesFree) {
          html +=
            '<p class="md-pdp__shipping-calc-result-line md-pdp__shipping-calc-result-line--free">' +
            applyTemplate(i18n.free || 'Frete grátis — __METHOD__', {
              method: methodName,
            }) +
            '</p>';
        } else if (shippingCents != null) {
          var thresholdMoney = formatMoney(
            Number(config.freeShippingMinCents) || 0,
            moneyFormat,
            currencyCode
          );
          var rateText = applyTemplate(
            i18n.rateWithThreshold ||
              i18n.rate + ' / frete grátis nas compras a partir de __AMOUNT__',
            {
              method: methodName,
              price: formatMoney(shippingCents, moneyFormat, currencyCode),
              amount: thresholdMoney,
            }
          );
          html +=
            '<p class="md-pdp__shipping-calc-result-line md-pdp__shipping-calc-result-line--price">' +
            rateText +
            '</p>';
        }

        html +=
          '<p class="md-pdp__shipping-calc-result-line md-pdp__shipping-calc-result-line--delivery">' +
          applyTemplate(deliveryTpl || 'Entrega em até __DAYS__ dias úteis.', {
            days: String(deliveryDays),
          }) +
          '</p>';

        if (address.localidade && uf) {
          html +=
            '<p class="md-pdp__shipping-calc-result-line md-pdp__shipping-calc-result-line--city">' +
            address.localidade +
            ' — ' +
            uf +
            '</p>';
        }

        renderResult(el, html, false);
      })
      .catch(function () {
        renderResult(el, '<p>' + (i18n.error || 'Erro ao calcular.') + '</p>', true);
      })
      .finally(function () {
        setLoading(el, config, false);
      });
  }

  function initEl(el) {
    if (el.dataset.mdShippingCalcInit === 'true') return;
    el.dataset.mdShippingCalcInit = 'true';

    var config = readConfig(el);
    if (!config) return;

    var form = el.querySelector('[data-md-shipping-calc-form]');
    var input = el.querySelector('[data-md-shipping-cep]');

    if (input) {
      try {
        var cached = sessionStorage.getItem(CEP_CACHE_KEY);
        if (cached) input.value = formatCep(cached);
      } catch (err) {
        /* ok */
      }

      input.addEventListener('input', function () {
        var digits = normalizeCep(input.value);
        input.value = formatCep(digits);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        calculate(el, config);
      });
    }
  }

  function initRoot(root) {
    (root || document).querySelectorAll('[data-md-shipping-calc]').forEach(initEl);
  }

  function init() {
    initRoot(document);
  }

  global.VestfirmaPdpShippingCalculator = {
    init: init,
    initRoot: initRoot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
